module.exports = __webpack_public_path__ + "joy-static/media/img_1.9cb212b5.png";